/*
 * DD AdminUI
 * Copyright (C) Fraunhofer IESE 2019 - 2025 Stefan Schweitzer, Shyalan Ramesh, Rafael Aranda López King,
 * Florian Wege, Johannes Schneider, Kazi Rezoanur Rahman, Christoph Müller, Pedram Jokar,
 * Mher Ter-Tovmasyan, Ben Burkhard, Matthias Gerbershagen, Anna Kleiner, Muhammad Tariq,
 * Adeline Silva Schäfer
 *
 * SPDX-License-Identifier: Apache-2.0
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */

import React from 'react';
import AppBar from '@mui/material/AppBar';
import Toolbar from '@mui/material/Toolbar';
import Typography from '@mui/material/Typography';
import { Button } from '@mui/material';
import makeStyles from '@mui/styles/makeStyles';
import logo from '../../../assets/images/administierbar-logo.svg';
import { keycloak } from '../../auth/AuthProvider';

interface Props {
	title: string;
}

const useStyles = makeStyles(() => ({
	logoStyle: {
		marginLeft: '-10px',
		marginRight: '20px',
		height: '60px',
		width: '60px',
		padding: '5px'
	},
	mainTitle: {
		flexGrow: 1,
		fontStyle: 'normal',
		fontWeight: 500,
		fontSize: '28px',
		lineHeight: '37px',
		letterSpacing: '0.02em',
		color: '#FFFFFF'
	}
}));

export const TopNavigationView = (props: Props): JSX.Element => {
	const classes = useStyles();
	const { title } = props;

	const logout = () => keycloak.logout();

	function onLogout(e: React.MouseEvent): void {
		e.preventDefault();
		logout();
	}

	return (
		<>
			<AppBar position="fixed" style={{ userSelect: 'none' }}>
				<Toolbar>
					<img src={logo} alt="AdministrierBar Logo" className={classes.logoStyle} />
					<Typography className={classes.mainTitle}>{title}</Typography>
					<Button color="inherit" onClick={onLogout}>
						Ausloggen
					</Button>
				</Toolbar>
			</AppBar>
		</>
	);
};
